module.exports = __webpack_public_path__ + "img/output-8.eb375c13.png";